import React from "react";
import Navbar from "../components/Navbar";
import Expo from "../components/Expo";
import Aside from "../components/Aside";
import Footer from "../components/Footer";

const ExpoPage = () => {
  return (
    <>
      <Navbar />
      <Expo />
      <Aside />
      <Footer />
    </>
  );
};

export default ExpoPage;
